if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.cc-main-product');
      this.form = document.getElementById(this.dataset.formId);
      this.nativeButton = this.form?.querySelector('[name="add"]');
      this.button = this.querySelector('[data-sticky-submit]');
      this.total = this.querySelector('[data-sticky-total]');
      if (!this.nativeButton || !this.button) return;
      this.price = Number(this.dataset.price);
      this.sampleButton = this.querySelector('[data-sticky-sample]');
      this.sampleWrap = this.section?.querySelector('.bd-sample-order-wrap:not([data-sample-scope="card"])');
      this.syncSample = () => {
        const nativeSample = this.sampleWrap?.querySelector('.js-sample-order');
        this.sampleButton.hidden = !nativeSample || nativeSample.hidden;
        this.sampleButton.disabled = !nativeSample || nativeSample.disabled || nativeSample.getAttribute('aria-disabled') === 'true';
        if (nativeSample) this.sampleButton.textContent = nativeSample.textContent.trim();
      };
      this.submitSample = () => {
        this.syncSample();
        if (!this.sampleButton.hidden && !this.sampleButton.disabled) this.sampleWrap.querySelector('.js-sample-order').click();
      };
      this.sampleButton.addEventListener('click', this.submitSample);
      if (this.sampleWrap) {
        this.sampleObserver = new MutationObserver(this.syncSample);
        this.sampleObserver.observe(this.sampleWrap, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'disabled', 'aria-disabled']});
      }
      this.syncSample();
      this.sync = this.sync.bind(this);
      this.submit = () => {
        this.sync();
        if (!this.button.disabled) this.nativeButton.click();
      };
      this.button.addEventListener('click', this.submit);
      this.form.addEventListener('input', this.sync);
      this.form.addEventListener('change', this.sync);
      this.stateObserver = new MutationObserver(this.sync);
      this.stateObserver.observe(this.nativeButton, {attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true});
      this.updateVisibility = () => {
        this.visibilityFrame = null;
        const rect = this.nativeButton.getBoundingClientRect();
        const footer = document.querySelector('.bd-footer');
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const passed = rect.bottom < 0 && !footerVisible;
        document.body.classList.toggle('bd-purchase-controls-visible', rect.bottom > 0 && rect.top < window.innerHeight);
        this.classList.toggle('sticky-atc-panel--out', !passed);
        this.inert = !passed;
      };
      this.scheduleVisibility = () => {
        if (!this.visibilityFrame) this.visibilityFrame = requestAnimationFrame(this.updateVisibility);
      };
      this.visibilityObserver = new IntersectionObserver(this.updateVisibility);
      this.visibilityObserver.observe(this.nativeButton);
      window.addEventListener('scroll', this.scheduleVisibility, {passive: true});
      window.addEventListener('resize', this.scheduleVisibility, {passive: true});
      this.updateVisibility();
      this.sync();
    }

    sync() {
      const quantity = Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value) || 1);
      this.total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      }).format(this.price * quantity / 100);
      this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.nativeButton.textContent.trim();
    }

    disconnectedCallback() {
      document.body.classList.remove('bd-purchase-controls-visible');
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.visibilityFrame);
      window.removeEventListener('scroll', this.scheduleVisibility);
      window.removeEventListener('resize', this.scheduleVisibility);
      this.stateObserver?.disconnect();
      this.sampleObserver?.disconnect();
      this.sampleButton?.removeEventListener('click', this.submitSample);
      this.form?.removeEventListener('input', this.sync);
      this.form?.removeEventListener('change', this.sync);
      this.button?.removeEventListener('click', this.submit);
    }
  }
  customElements.define('sticky-atc-panel', StickyAtcPanel);
}

